import { useGetTableColumnSettingsQuery } from "store/api/auth";
import {
  useChangePasswordMutation,
  useDeleteProfileMutation,
  useEditProfileMutation,
  useFileUploadMultipleDocumentMutation,
  // eslint-disable-next-line import/named
  useFileUploadMultipleMutation,
  // eslint-disable-next-line import/named
  useFileUploadMultipleVideoMutation,
  useFileUploadMutation,
  useGlobalConfigQuery,
  useImageUploadMutation,
  useProfileQuery,
} from "store/api/profile";
import { fixedCacheKeys } from "utils/fixedCacheKeys";

export const useProfileHook = () => {
  /** ***************** 
  @purpose : Used For handle get and reset data
  @Parameter : {data,reset}
  @Author : INIC
  ***************** */

  const { data: userData, refetch: refetchUserData } = useProfileQuery();
  const [editProfile, { isLoading: profileLoading }] = useEditProfileMutation({
    fixedCacheKey: fixedCacheKeys.EDIT_PROFILE,
  });

  const [imageUpload] = useImageUploadMutation({
    fixedCacheKey: fixedCacheKeys.IMAGE_UPLOAD,
  });

  const [fileUpload] = useFileUploadMutation({
    fixedCacheKey: fixedCacheKeys.FILE_UPLOAD,
  });
  const [fileUploadMultiple] = useFileUploadMultipleMutation({
    fixedCacheKey: fixedCacheKeys.FILE_UPLOAD_MULTIPLE,
  });
  const [fileUploadMultipleVideo] = useFileUploadMultipleVideoMutation({
    fixedCacheKey: fixedCacheKeys.FILE_UPLOAD_MULTIPLE_VIDEO,
  });
  const [fileUploadMultipleDocument] = useFileUploadMultipleDocumentMutation({
    fixedCacheKey: fixedCacheKeys.FILE_UPLOAD_MULTIPLE_DOCUMENT,
  });
  const { data: globalConfigData } = useGlobalConfigQuery({
    refetchOnMountOrArgChange: true,
  });

  const [changePassword, { isLoading: passwordLoading }] =
    useChangePasswordMutation({
      fixedCacheKey: fixedCacheKeys.CHANGE_PASSWORD,
    });

  const [deleteProfile, { isLoading: deleteProfileLoading }] =
    useDeleteProfileMutation({
      fixedCacheKey: fixedCacheKeys.DELETE_PROFILE,
    });

  const { data: columnTableSettingData } = useGetTableColumnSettingsQuery();

  return {
    changePassword,
    passwordLoading,
    profileLoading,
    userData,
    editProfile,
    fileUpload,
    fileUploadMultiple,
    fileUploadMultipleVideo,
    fileUploadMultipleDocument,
    refetchUserData,
    globalConfigData,
    deleteProfile,
    deleteProfileLoading,
    columnTableSettingData,
    imageUpload,
  };
};
